import { preloadPostOfficeScreenSpaceFlags } from '@atlassian/confluence-post-office-provider/entry-points/screen-space-flags-placement';

import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';

export async function preloadScreenSpaceFlags(match: RouteMatch | null) {
	const { userId } = getPreloaderFnContext();
	if (!userId || !match) {
		return;
	}

	return SSRMeasures.run('ssr-app/prepare/preloadQuery/postOffice:ScreenSpaceFlags', async () => {
		return preloadPostOfficeScreenSpaceFlags(match);
	});
}
